import React from 'react';



class CardImage extends React.Component{

  constructor(props) {
    super(props);
    this.state = {image: "loading"};
    this.handleImageLoaded = this.handleImageLoaded.bind(this);
    this.handleImageErrored = this.handleImageErrored.bind(this);
  }

  handleImageErrored(){
   this.setState({image : "error"});
  }

  handleImageLoaded(){
  this.setState({image : "loaded"});
 }

 componentDidMount(){
   try{
     var image = new Image();
     image.src = this.props.imageUrl;
     image.onload = () => {
     this.setState({image : "loaded"});

    }}catch(err) {

        console.log(err);

    };
 }
  render(){
    var src = "";
    var whenNoImage = "https://d2hfzg3ugxeze1.cloudfront.net/venues-listing/venue_fallback.png";
    try{
         src = this.props.imageUrl;
          if(!src){
            src = whenNoImage;
         }
    }catch(err){
            src = whenNoImage;
    }
      var fallback = "https://d2hfzg3ugxeze1.cloudfront.net/venues-listing/venue_fallback.png";
      var name = this.props.name;


    return (
      <div className="card-image-div">

        <img src= {this.state.image == "loaded" ? src : fallback} className="card-venue-image"
              alt= {name}  />

        </div>
      )
    }

  }

  export default CardImage;



// WEBPACK FOOTER //
// ./src/components/Offers/cardImage.js